// extracted by mini-css-extract-plugin
export default {"link":"KQL_W_ovEnU8sawGuhIb","label":"JHOSpaE7B1CSMndBIoLa","bounce":"sQ7jOS5Q_HsgI0ewWRar"};